import { RowActionMui } from '@app/components/table/RowActionMui';
import { RowActions } from '@app/components/table/RowActions';
import { buildLoggerStreamUrl } from '@app/modules/logger/screens/stream/helpers/build-logger-stream-url';
import { MinimumStation, Station } from '@mi-front/core';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { defineMessage, useIntl } from 'react-intl';

const openLoggerAtTimeMessage = defineMessage({
  id: 'logger.reports.streamQuality.availability.table.action.openLogger',
  defaultMessage: 'Abrir el logger en este momento',
});

export type OpenLoggerRowActionProps = {
  station: Station | MinimumStation;
  /** Opens the logger stream with the cursor at this instant (event start). */
  at: Date;
};

/**
 * Row action: navigate to the logger stream for the station at the given timestamp (new tab).
 */
export function OpenLoggerRowAction({ station, at }: OpenLoggerRowActionProps) {
  const { $t } = useIntl();
  const url = buildLoggerStreamUrl(station.slug, { cursor: at.getTime() });
  return (
    <RowActions>
      <RowActionMui title={$t(openLoggerAtTimeMessage)} link={url}>
        <OpenInNewIcon fontSize="small" />
      </RowActionMui>
    </RowActions>
  );
}
